import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  return (
    <>
      {/* Overlay */}
      <div
        className={`overlay ${isOpen ? 'active' : ''}`}
        onClick={toggleSidebar}
      ></div>

      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <button className="btn btn-primary" onClick={toggleSidebar}>
          Close Sidebar
        </button>
        <ul className="list-unstyled mt-3">
          <li>Home</li>
          <li>About</li>
          <li>Services</li>
          <li>Contact</li>
        </ul>
      </div>
    </>
  );
};

export default Sidebar;